import { DocumentNode, gql } from '@apollo/client';

// Statisches Dokument mit GraphQL-Variablen (keine String-Interpolation mehr).
// Insbesondere searchInput wird als Variable übergeben und nicht mehr in den
// Query-Text interpoliert.
export const getRecyclingProcessesByFilterQuery: DocumentNode = gql`
  query GetRecyclingProcessesByFilter($startDate: DateTime!, $endDate: DateTime!, $hideInactiveProcesses: Boolean!, $searchInput: String!, $position: Int!, $take: Int!) {
    recyclingProcessesByFilter(startDate: $startDate, endDate: $endDate, hideInactiveProcesses: $hideInactiveProcesses, searchInput: $searchInput, position: $position, take: $take) {
      id
      correlationId
      processStart
      chosenProductCategory {
        id
        name
      }
      chosenManufacturer
      country {
        id
        name
        countryCode
        logisticTypeId
        localPartnerEmail
      }
      trackingId
      dateOfArrival
      dateOfCancellation
      arrivedProductCategory {
        id
        name
        isOther
      }
      arrivedProductCategoryOther
      serialNumber
    }
  }
`;
